import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { CountryModel } from "../models/country.model";

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  // Variables
  countries: CountryModel[];

  constructor(private http: HttpClient) { }

  /**
   * Get All Countries
   * @returns Promise<CountryModel[]> - The list of all countries
   */
  async getAllCountries(): Promise<CountryModel[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get<CountryModel[]>(
          `${environment.managementApi}/Countries/All`
        )
        .subscribe({
          next: (countries) => {
            resolve(countries);
          },
          error: (err) => {
            reject(err);
          }
        });
    });
  }
}
